import React from 'react'

export const RectangleIcon = () => (
  <svg width="4" height="24" viewBox="0 0 4 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="4" height="24" rx="2" fill="#161616" />
  </svg>
)
